module.exports = __webpack_public_path__ + "img/组 126@2x(5).f22f15fe.png";